export * from './entry/mainAny.js';


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/index.js
// module id = 1989
// module chunks = 2